import { useEffect } from 'react';

const useSEO = ({ title, description }) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    }

    // Cleanup - restore defaults when component unmounts
    return () => {
      document.title = 'React Tools - Free Online Developer Tools';
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Free online tools for developers - Convert, format, and transform data right in your browser');
      }
    };
  }, [title, description]);
};

export default useSEO;
